import React from 'react';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import { observer, inject } from 'mobx-react';
import { Switch, Route, Link } from 'react-router-dom';
import StartupsInfo from './StartupsInfo';
import ToolsInfo from './ToolsInfo';
import GoogleAnalytics from './GoogleAnalytics';
import UsersInfo from './UsersInfo';
import { injectIntl } from 'react-intl';

@injectIntl
@inject('growStore')
@observer
export default class Grow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, active: -1 };
  }

  openModal(idx) {
    this.setState({ isOpen: !this.state.isOpen, active: idx });
  }

  render() {
    const { intl } = this.props;

    return (
      <div style={{ marginTop: '30px' }}>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row className="clearfix">
            <Col sm={2}>
              <Nav bsStyle="pills" stacked>
                <NavItem eventKey="first">
                  {intl.formatMessage({ id: 'startups_info' })}
                </NavItem>
                <NavItem eventKey="second">
                  {intl.formatMessage({ id: 'tools_info' })}
                </NavItem>
                {/*<NavItem eventKey="third">{intl.formatMessage({ id: "users_info" })} </NavItem> */}
                {/*<NavItem eventKey="third"> Google Analytics</NavItem>*/}
              </Nav>
            </Col>
            <Col sm={10}>
              <Tab.Content animation>
                <Tab.Pane eventKey="first">
                  <StartupsInfo {...this.props} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <ToolsInfo {...this.props} />
                </Tab.Pane>
                {/* <Tab.Pane eventKey="third"><UsersInfo {...this.props}/></Tab.Pane> */}
                {/*<Tab.Pane eventKey="third"><GoogleAnalytics/></Tab.Pane>*/}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}
